module.exports = require("@swa-ui/vacations/src/CruiseBookingContainer/CruiseBookingContainer.module.scss");